// extracted by mini-css-extract-plugin
export default {"Session_container":"MainPageProducts_Session_container__PuQd-"};